import React from "react";
import axios from "axios";
import { URL, getAuthorizationHeader } from "../../constans/constants";
import { firmaEmpleado } from './RecibosService';
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { getUsuarioLogueado, getEmpresa, logout } from "../../components/login/SesionService"
import { Container, Form, Modal, Button, InputGroup } from 'react-bootstrap'
import Cookies from 'universal-cookie';
import { createGostCanvasAndGetAppareance, loadSignature } from "../tiposDocumento/AparienciaServicios";
import visibility_white from '../../styles/icons/visibility_white.svg';
import visibility_off from '../../styles/icons/visibility_off.svg';

class PinEmpleado extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      idLote: "",
      keystore: 0,
      formatoFirmaEmpleado: "",
      pin: "",
      respuesta: "",
      severity: "success",
      mostrarPantallaCarga: false,
      datosUsuarios: {},
      datosEmpresa: {},
      isFirmaEmpleado: false,
      validated: false,
      isLoaded: false,
      mostrarPassword: false,
      errors: {
        pin: null
      }
    };
  }

  handleClose = (data) => {
    this.props.handleClose(false, data);
  };

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  handleFirmasPDF = (tipoFirma, value) => {
    if (tipoFirma == 'EMP')
      this.setState({ isFirmaEmpleado: value })
  };

  validarCamposFormulario = () => {
    let errors = {}
    let isValid = false
    if (this.state.pin === null || this.state.pin.trim() === "") {
      errors = { pin: "Debe ingresar un Pin valido" }
      return { isValid, errors }
    } else
      isValid = true

    return { isValid, errors }
  }

  handlePinSubmit = async (event) => {
    event.preventDefault();
    const { isValid, errors } = this.validarCamposFormulario()
    if (!isValid) {
      this.setState({ errors: errors })
    } else {
      this.setState({ openPantallaCarga: true });
      if (this.props.formatoDocumento == "PDF") {
        var formatoEmpleado = await loadSignature(this.state.formatoFirmaEmpleado, this.state.datosUsuarios, this.state.datosEmpresa, false);
        var apariencia = null;
        var json = {
          appearance: null,
          keystoreId: this.state.keystore,
          pin: this.state.pin,
          idLote: this.props.idLote,
          idRecibo: this.props.idRecibo
        };
        if (formatoEmpleado.appearance) {
          json = await createGostCanvasAndGetAppareance(formatoEmpleado, json, this.props.estado, this.handleClose, this.handleFirmasPDF);
          await this.firmar(json);
        }
      } else {
        const json = {
          appearance: null,
          keystoreId: this.state.keystore,
          pin: this.state.pin,
          idLote: this.props.idLote,
          idRecibo: this.props.idRecibo
        };
        this.setState({ mostrarPantallaCarga: true });
        firmaEmpleado(json).then((response) => {
          this.handleClose(response);
        });
      }
    }
  };

  firmar = async (json)=>{
    if(this.props.estado == 'Pendientes'){
       firmaEmpleado(json).then((response) => {
        this.handleClose(response)
        return response;
      });
    }
  }

  componentDidMount() {
    const cookies = new Cookies();
    var token = {token:localStorage.getItem("tokenIscert"),
    psa:localStorage.getItem("codigoClienteFirma")}
    axios
      .post(URL + "payrolls/iscert/keystore",token,getAuthorizationHeader())
      .then((res) => {
        if (res.data.error == false) {
          this.setState({ keystore: res.data.datos.keystores[0].id, isLoaded: true });
        } else {
          this.setState({
            severity: "danger",
            respuesta: res.data.mensaje
          });
          this.handleClose(res.data);
        }
      }, error => {
        if (error.response.status === 401) {
         logout();
        }
        return error;
      })
    axios
      .get(
        URL + "lote/getEmpleadoSignFormat/" + this.props.idLote + "/"+cookies.get('username'),
        getAuthorizationHeader()
      )
      .then((res) => {
        if (res.data.error == false)
          this.setState({ formatoFirmaEmpleado: res.data.datos });
      }, error => {
        if (error.response.status === 401) {
         logout();
        }
        return error;
      })
    getUsuarioLogueado().then((response) => {
      this.setState({ datosUsuarios: response });
    });
    getEmpresa().then((response) => {
      this.setState({ datosEmpresa: response })
    });
  }

  setMostrarPassword = () => {
    this.setState(prevState => ({ mostrarPassword: !prevState.mostrarPassword }))
  }

  handleInput = (e) => {
    var name = e.target.name;
    var val = e.target.value;
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [name]: null
      },
      [name]: val,
    }))
  };

  render() {
    return (
      <Container>
        <PantallaCarga open={this.state.openPantallaCarga} />
        <Form noValidate validated={this.state.validated} onSubmit={this.handlePinSubmit}>
          <Modal.Header closeButton>
            <Modal.Title style={{ color: "#0c56d0" }}> {this.props.dialogTitle} </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="datosLotes">
              <p className="form-date">
              {" "}
              <strong>Confirmar datos:</strong>
              </p>
              <div className="lote-date"> Lote: {this.props.loteRecibo} | fecha: {this.props.fecha} </div>
              <div className="lote-row">
                <p className="lote-text"> <strong>Concepto: </strong> {this.props.concepto} </p>
              </div>
            </div>
            <p className="form-date"> <strong> Ingresa el Pin de Firma para firmar el recibo seleccionado:</strong> </p>
            <Form.Group className="form-group md-input" style={{marginBottom: '1rem'}}>
              <InputGroup>
                <Form.Control
                  id="pin"
                  type={!this.state.mostrarPassword ? "password" : "text"}
                  name="pin"
                  onChange={this.handleInput}
                  value={this.state.pin}
                  isInvalid={!!this.state.errors.pin}
                  required
                />
                <Button onClick={this.setMostrarPassword}>
                  <img src={this.state.mostrarPassword ? visibility_off : visibility_white}
                    alt="toggle visibility" style={{ width: '15px', height: '15px' }}
                  />
                </Button>
                <Form.Control.Feedback type="invalid">
                  <small>{this.state.errors.pin}</small>
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>

          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => this.handleClose(null)} variant="contained" color="primary">
              Cancelar
            </Button>
            <Button autoFocus color="primary" type="submit" disabled={!this.state.isLoaded}>
              Firmar
            </Button>
          </Modal.Footer>
        </Form>
      </Container>
    );
    //}

  }
}

export default PinEmpleado;
